import useCountUp from "../../hooks/use-count-up";

type Props = {
  value: number;
  formatter: (value: number) => string;
};

const AnimatedNumber = ({ value, formatter }: Props) => {
  const animated = useCountUp(value);
  return <>{formatter(animated)}</>;
};

export default AnimatedNumber;
